//越南语
export default {
	login: {
		salesBackend: "Đăng nhập Hệ thống Bán hàng OMELINK",
		account: "Tài khoản",
		password: "Mật khẩu",
		login: "Đăng nhập",
		pleaseEnter: "Vui lòng nhập",
		userName: "Tên đăng nhập",
		loginSuccessful: "Đăng nhập thành công",
		usingOa: "Đăng nhập bằng tài khoản OA của bạn",
		usingSjfood: "Đăng nhập bằng tài khoản HiFood của bạn",
	},
	index: {
		customerSettings: "Cài đặt Khách hàng",
		personalInformation: "Thông tin Cá nhân",
		logOut: "Đăng xuất",
		selectLanguage: "Chọn Ngôn ngữ",
		confirmExit: "Xác nhận thoát?",
		hint: "Gợi ý",
		productSettings: "Cài đặt Sản phẩm",
		syncSettings: "Cài đặt Đồng bộ",
		customerBinding: "Liên kết Khách hàng",
	},
	personal: {
		avatar: "Ảnh đại diện",
		nickName: "Biệt danh",
	},
	operator: {
		addTo: "Thêm vào",
		authorizer: "Người ủy quyền",
		permissions: "Quyền hạn",
		startingTime: "Thời gian bắt đầu",
		endTime: "Thời gian kết thúc",
		revise: "Chỉnh sửa",
		delete: "Xóa",
		viewPermissions: "Xem Quyền hạn, Gửi Quyền hạn",
	},
	customer: {
		customerCode: "Mã Khách hàng",
		customerName: "Tên Khách hàng",
		warehouse: "Kho hàng",
		customerBindingQuantity: "Số lượng Liên kết Khách hàng",
		maintenanceQuantity: "Số lượng Bảo trì Thay đổi Vật liệu",
		operate: "Thao tác",
		customerBinding: "Liên kết Khách hàng",
		productSettings: "Cài đặt Sản phẩm",
		batchOpertion: "Bảo trì Hàng loạt",
		selectCustomer: "Chọn Khách hàng",
		importItem: "Nhập Mặt hàng",
		batchImportItem: "Nhập Mặt hàng Hàng loạt",
		successfully: "Hoàn thành",
		previousStep: "Bước Trước",
		nextStep: "Bước Tiếp theo",
		selectFile: "Chọn Tệp",
		templateDownload: "Tải Xuống Mẫu",
		noFileSelected: "Chưa chọn tệp nào",
		downloadingTemplate: "Tải xuống mẫu thành công",
		operationSuccess: "Bảo trì hàng loạt thành công",
		aTotalOf: "Tổng cộng",
		errorTips: "mặt hàng hệ thống phát hiện có lỗi ID, nhập thất bại! Vui lòng kiểm tra và thử lại.",
		importSuccessfully: "Nhập thành công",
	},
	customerProduct: {
		myClient: "Khách hàng của tôi",
		productSettings: "Cài đặt Sản phẩm",
		specification: "Thông số kỹ thuật",
		editedSuccessfully: "Chỉnh sửa thành công!",
	},
	customerProductLastest: {
		myClient: "Khách hàng của tôi",
		productSettings: "Cài đặt Sản phẩm",
		syncSettings: "Cài đặt Đồng bộ",
		changeUpdates: "Kiểm tra Cập nhật Thay đổi Sản phẩm",
		old: "Cũ",
		new: "Mới",
		state: "Trạng thái",
		waitingForConfirmation: "Đang chờ xác nhận",
		applied: "Đã áp dụng",
		notApplied: "Không áp dụng",
		operate: "Thao tác",
		newAdditions: "Thêm mới",
		renew: "Gia hạn",
		time: "Thời gian",
		SALESConfirmed: "SALES Đã xác nhận",
		application: "Ứng dụng",
		successfulOperation: "Thao tác thành công!",
	},
	customerPhone: {
		myClient: "Khách hàng của tôi",
		customerBinding: "Liên kết Khách hàng",
		addBinding: "Thêm Liên kết",
		noData: "Không có dữ liệu, vui lòng thêm",
		telephoneNumber: "Số điện thoại",
		remarkName: "Tên ghi chú",
		memorandum: "Ghi chú",
		smsDisable: "Tắt SMS",
		operate: "Thao tác",
		edit: "Chỉnh sửa",
		unbind: "Hủy liên kết",
		CRMContact: "Chọn Liên hệ CRM",
		enterANote: "Nhập ghi chú",
		editBinding: "Chỉnh sửa Liên kết",
		correctPhoneNumber: "Vui lòng nhập đúng định dạng số điện thoại",
		ContentIsTooLong: "Vui lòng nhập ghi chú",
		bindingSuccessfully: "Liên kết thêm thành công!",
		errorMessage: "Thông tin điền có lỗi!",
		successfulOperation: "Thao tác thành công!",
		setupSuccessful: "Thiết lập thành công!",
		closedSuccessfully: "Đóng thành công!",
		unbindHint: "Bạn có chắc chắn muốn hủy liên kết?",
		hint: "Gợi ý",
		UnbindingSuccessful: "Hủy liên kết thành công!",
		numberIdentityNote: "Số, Danh tính, Ghi chú",
		selectIdentityNote: "Chọn Ghi chú Danh tính",
		customRemarks: "Tùy chỉnh Số Danh tính Ghi chú",
		pleaseEnterCustomRemarks: "Vui lòng nhập ghi chú tùy chỉnh số danh tính",
		manager: "Quản lý",
		boss: "Sếp",
		headChef: "Bếp trưởng",
		accountant: "Kế toán",
		custom: "Tùy chỉnh",
		phoneEditDelateGuid: "Không thể thao tác trên liên hệ từ CRM. Vui lòng thực hiện thao tác trong CRM.",
        billManagement: "Quản lý Hóa đơn",
        add: "Thêm mới",
	},
	productSpecification: {
		addTo: "Thêm vào",
		nameSearch: "Nhập tên thông số để tìm kiếm",
		specificationName: "Tên Thông số",
		operate: "Thao tác",
		edit: "Chỉnh sửa",
		editSpecifications: "Chỉnh sửa Thông số",
		attributes: "Thuộc tính",
		addAttributes: "Vui lòng thêm thuộc tính",
		name: "Tên",
		optionName: "Nhập tên tùy chọn",
		enterSpecificationName: "Vui lòng nhập tên thông số!",
		addOptions: "Vui lòng thêm tùy chọn!",
		editedSuccessfully: "Chỉnh sửa thành công!",
		errorMessage: "Thông tin điền có lỗi!",
		enterAttributeName: "Nhập tên thuộc tính",
		sureDelete: "Bạn có chắc chắn muốn xóa?",
		hint: "Gợi ý",
		successfullyDeleted: "Xóa thành công!",
		cannotSortWhenSearching: "Không thể sắp xếp khi đang tìm kiếm",
		sortingSaveFail: "Sắp xếp lưu thất bại",
		sortingSaveSuccess: "Sắp xếp lưu thành công",
	},
	productHistory: {
		materialChange: "Bảo trì Thay đổi Vật liệu",
		aliasSearch: "Nhập tên sản phẩm hoặc biệt danh để tìm kiếm",
		noData: "Không có dữ liệu",
		productName: "Tên Sản phẩm",
		productAlias: "Biệt danh Sản phẩm",
		category: "Danh mục",
		state: "Trạng thái",
		enable: "Bật",
		disable: "Tắt",
		operate: "Thao tác",
		edit: "Chỉnh sửa",
		codingImportGoods: "Nhập sản phẩm theo mã khách hàng",
		importProducts: "Nhập sản phẩm",
		enterCustomerCode: "Nhập mã khách hàng",
		selectProduct: "Chọn sản phẩm",
		finish: "Hoàn thành",
		customerCode: "Mã Khách hàng",
		nextStep: "Bước tiếp theo",
		cancelSelection: "hủy chọn",
		previous: "Trước",
		import: "Nhập",
		aTotalOf: "Tổng cộng ",
		productImportSuccess: "sản phẩm đã được nhập thành công",
		productImportFailure: "sản phẩm bị hệ thống phát hiện trùng lặp và nhập thất bại! Vui lòng kiểm tra trước khi nhập.",
		pleaseEnterCustomerCode: "Vui lòng nhập mã khách hàng!",
		messageInformationCorrectly: "Vui lòng điền thông tin chính xác!",
		pleaseSelectProduct: "Vui lòng chọn thông tin sản phẩm bạn muốn nhập!",
	},
	productEdit: {
		editProductInformation: "Chỉnh sửa Thông tin Sản phẩm",
		basicInformation: "Thông tin Cơ bản",
		productName: "Tên Sản phẩm",
		productAlias: "Biệt danh Sản phẩm",
		category: "Danh mục",
		state: "Trạng thái",
		enable: "Bật",
		disable: "Tắt",
		specificationInformation: "Thông tin Thông số",
		selectSpecifications: "Chọn Thông số",
		deleteSpecification: "Xóa Thông số",
		enterSpecificationName: "Nhập tên thông số",
		addSpecs: "Thêm thông số",
		pleaseChoose: "Vui lòng chọn",
		attributes: "Thuộc tính",
	},
	productAll: {
		aliasSearch: "Nhập tên sản phẩm hoặc biệt danh để tìm kiếm",
		noData: "Không có dữ liệu",
		productName: "Tên Sản phẩm",
		productAlias: "Biệt danh Sản phẩm",
		category: "Danh mục",
		state: "Trạng thái",
		enable: "Bật",
		disable: "Tắt",
		operate: "Thao tác",
		edit: "Chỉnh sửa",
		insert: "Chèn",
		insertingSuccessfully: "Chèn lịch sử thành công!",
	},
	avatar: {
		setAvatar: "Đặt Ảnh đại diện",
		preview: "Xem trước",
		changePicture: "Đổi ảnh",
		enlarge: "Phóng to",
		zoomOut: "Thu nhỏ",
		rotateLeft: "Xoay trái",
		rotateRight: "Xoay phải",
		upload: "Tải lên",
		errorGetAvatar: "Không thể lấy ảnh đại diện, vui lòng thử lại sau",
		sizeCannotExceed: "Kích thước ảnh đại diện tải lên không vượt quá 2MB!",
		selectPicture: "Chọn ảnh",
		setupSuccessful: "Thiết lập thành công",
		uploadFailed: "Tải lên thất bại, vui lòng thử lại sau",
	},
	addSpecification: {
		addSpecs: "Thêm thông số",
		specificationName: "Tên Thông số",
		attributes: "Thuộc tính",
		addAttributes: "Vui lòng thêm thuộc tính",
		addTo: "Thêm vào",
		name: "Tên",
		operate: "Thao tác",
		delete: "Xóa",
		addProperties: "Thêm thuộc tính",
		enterAttributeName: "Nhập tên thuộc tính",
		enterSpecificationName: "Nhập tên thông số!",
		addOptions: "Thêm tùy chọn",
		addedSuccessfully: "Thêm thành công!",
		errorMessage: "Thông tin điền có lỗi!",
	},
	chatEmojiPicker: {
		recent: "Gần đây",
		people: "Con người",
		nature: "Thiên nhiên",
		foods: "Thực phẩm",
		activity: "Hoạt động",
		places: "Địa điểm",
		objects: "Đối tượng",
		symbols: "Biểu tượng",
		flags: "Cờ",
	},
	chatHistoryMessage: {
		viewContext: "Xem Ngữ cảnh",
		copy: "Sao chép",
		save: "Lưu",
		copiedToClipboard: "Đã sao chép vào clipboard",
		copyFailed: "Sao chép thất bại",
		errorTextMessage: "Tạm thời chỉ hỗ trợ sao chép tin nhắn văn bản",
		errorMessage: "Tạm thời chỉ hỗ trợ lưu tin nhắn thoại",
	},
	chatHistory: {
		enterChatContent: "Nhập nội dung trò chuyện",
		back: "Quay lại",
	},
	chatMessageCheckDetails: {
		serialNumber: "Số sê-ri",
		amount: "Số lượng",
		uploadDate: "Ngày tải lên",
		frontPicture: "Ảnh mặt trước Séc",
		reversePicture: "Ảnh mặt sau Séc",
		supplier: "Nhà cung cấp",
		userAmount: "Số lượng Người dùng Nhập",
		checkStatus: "Trạng thái Kiểm tra",
	},
	chatMessageCheck: {
		checkUploadReminder: "Nhắc nhở Tải lên Séc",
		checkCheckUpload: "Kiểm tra Tải lên Séc",
		checkDetails: "Chi tiết Kiểm tra",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "Phiên bản của bạn quá thấp để xem nội dung này",
	},
	chatMessageOrder: {
		orderDetails: "Chi tiết Đơn hàng",
		order: "Đơn hàng",
		deliveryDate: "Ngày giao hàng",
		productsOrdered: "Sản phẩm đã đặt",
		productsInclude: "Sản phẩm bao gồm",
		viewOrder: "Xem đơn hàng",
	},
	chatMessageReadStatus: {
		haveRead: "Đã đọc",
		unread: "Chưa đọc",
		readingStatus: "Trạng thái Đọc",
	},
	chatMessageStatus: {
		resendThisMessage: "Gửi lại tin nhắn này?",
		hint: "Gợi ý",
	},
	chatMessageText: {
		translateText: "Dịch Văn bản",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "Giọng nói bị hỏng",
	},
	chatMessages: {
		retractedMessage: "Bạn đã thu hồi một tin nhắn",
		copy: "Sao chép",
		save: "Lưu",
		recall: "Thu hồi",
		concealTranslated: "Ẩn Bản dịch",
		translated: "Đã dịch",
		copiedToClipboard: "Đã sao chép vào clipboard",
		copyFailed: "Sao chép thất bại",
		supportsTextMessages: "Tạm thời chỉ hỗ trợ sao chép tin nhắn văn bản",
		supportsTextVoice: "Tạm thời chỉ hỗ trợ lưu tin nhắn thoại",
		supportsTexttranslated: "Tạm thời chỉ hỗ trợ dịch văn bản",
	},
	chatPicturePaster: {
		sendThisImage: "Gửi ảnh này?",
		send: "Gửi",
	},
	chatRecorder: {
		recording: "Đang ghi âm",
		stop: "Dừng",
		send: "Gửi",
		recordingFailed: "Ghi âm thất bại",
		timeShort: "Thời gian nói quá ngắn",
		timeLong: "Thời gian nói quá dài",
		microphonePermissionDenied: "Ghi âm thất bại, vui lòng cho phép truy cập micro.",
	},
	contactList: {
		remarkName: "Tên ghi chú:",
	},
	contacts: {
		contactPerson: "Người liên hệ",
	},
	conversationList: {
		recentChat: "Trò chuyện gần đây",
		remarkName: "Tên ghi chú:",
		cancelStick: "Bỏ ghim",
		haveRead: "Đã đọc",
		unread: "Chưa đọc",
		stick: "Ghim",
		pinnedSuccessfully: "Ghim thành công!",
		unpinnedSuccessfully: "Bỏ ghim thành công!",
	},
	detailContact: {
		chatInformation: "Thông tin Trò chuyện",
		METISusageCount: "Số lần Sử dụng METIS:",
		leftOver: "Còn lại",
		strip: "Dải",
		nickName: "Biệt danh",
		remarkName: "Tên ghi chú",
		revise: "Chỉnh sửa",
		associatedCustomers: "Khách hàng Liên quan",
		none: "Không có",
		smartResponse: "Dịch vụ Khách hàng METIS Thông minh",
		open: "Mở",
		close: "Đóng",
		automaticTranslation: "Dịch tự động",
		setupSuccessful: "Thiết lập thành công!",
		enterRemarks: "Nhập ghi chú",
		hint: "Gợi ý",
		yes: "CÓ",
		no: "KHÔNG",
		phoneNumber: "Số điện thoại",
		openTip1: "PST 13:30 - 01:00 ngày hôm sau theo giờ PST",
		openTip2: "Trong khoảng thời gian này, nếu mục đích câu hỏi của khách hàng được nhận diện là vấn đề đã biết, METIS sẽ phản hồi bình thường.",
		openTip3: "Trong khoảng thời gian này, nếu mục đích câu hỏi của khách hàng được nhận diện là vấn đề chưa nắm bắt, METIS sẽ không phản hồi.",
		userDoesNotBelong: "Người dùng hiện tại không phải là liên hệ của bạn",
	},
	detailGroup: {
		groupInformation: "Thông tin Nhóm",
		groupChatName: "Tên Nhóm Chat:",
		modifyGroupName: "Sửa Tên Nhóm",
		addMember: "Thêm Thành viên",
		noData: "Không có dữ liệu, vui lòng thêm",
		avatar: "Ảnh đại diện",
		nickName: "Biệt danh",
		groupNotes: "Ghi chú Nhóm",
		operate: "Thao tác",
		editorNotes: "Chỉnh sửa Ghi chú",
		removeMember: "Xóa Thành viên",
		userDoesNotBelong: "Người dùng hiện tại không thuộc nhóm này!",
		enterTheCommentName: "Nhập tên ghi chú của thành viên",
		hint: "Gợi ý",
		selectMembers: "Chọn thành viên",
		pleaseEnterTheGroupChatName: "Vui lòng nhập tên nhóm chat",
		groupNameHasNotChanged: "Tên nhóm chưa thay đổi!",
		groupNameCannotBeEmpty: "Tên nhóm không được để trống!",
		confirmToRemoveMember: "Xác nhận xóa thành viên?",
	},
	groupList: {
		groupChat: "Nhóm Chat",
		createGroupChat: "Tạo Nhóm Chat",
		groupName: "Tên Nhóm:",
	},
	selectMember: {
		selectMembers: "Chọn Thành viên",
		chosen: "Đã chọn:",
		contactPerson: "Người liên hệ",
		salesperson: "Nhân viên bán hàng",
		groupChat: "Nhóm Chat của ",
		atLeast: "Cần ít nhất 3 thành viên để tạo nhóm chat",
	},
	chat: {
		realTimeServer: "Kết nối máy chủ thời gian thực thất bại, đang kết nối...",
		enterSearchContent: "Nhập nội dung tìm kiếm",
		recentChat: "Trò chuyện gần đây",
		addressBook: "Danh bạ",
		groupChat: "Nhóm Chat",
		chatRecord: "Lịch sử Chat",
		selectLanguage: "Chọn Ngôn ngữ",
		ctrlEnter: "Nhấn Ctrl + Enter để gửi tin nhắn",
		commandEnter: "Nhấn Command + Enter để gửi tin nhắn",
		enter: "Nhấn Enter để gửi tin nhắn",
		translateContent: "Dịch Nội dung",
		send: "Gửi",
		imageUploadFailed: "Tải ảnh lên thất bại, vui lòng thử lại",
		onlyWithdrawMessages: "Bạn chỉ có thể thu hồi tin nhắn của mình",
		fileError: "Không thể đọc thông tin tệp video!",
		loadFailed: "Tải thất bại, nhấn để thử lại",
		loading: "Đang tải...",
		fileErrorTip: "Gửi thất bại. Định dạng tập tin hỗ trợ hình ảnh hoặc MP4, kích thước tập tin không vượt quá 300MB và thời lượng không quá 30 phút.",
		aFile: "tệp",
		errprTip: "Tải lên tệp thất bại, không thể gửi lại, vui lòng chọn lại tệp để tải lên.",
	},
	messageJS: {
		voice: "[Thoại]",
		picture: "[Ảnh]",
	},
	storeIndexJS: {
		have: "Có",
		unreadMessages: "tin nhắn chưa đọc",
		haveNewMessage: "Bạn có tin nhắn mới",
	},
	apiJS: {
		loginHasExpired: "Đăng nhập đã hết hạn, bạn có muốn đăng nhập lại?",
		hint: "Gợi ý",
		unknownMistake: "Lỗi không xác định",
	},
	router: {
		login: "Đăng nhập",
		customerCommunication: "Giao tiếp Khách hàng",
		setup: "Cài đặt",
		myClient: "Khách hàng của tôi",
		customerBinding: "Liên kết Khách hàng",
		productSettings: "Cài đặt Sản phẩm",
		syncSettings: "Cài đặt Đồng bộ",
		personalInformation: "Thông tin Cá nhân",
		authorizationSettings: "Cài đặt Ủy quyền",
		messageSending: "Gửi tin nhắn",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "Quản lý nhân viên số",
		omelinkUserServiceMaintenance: "OMELINK Dịch vụ quản lý",
	},
	dateJS: {
		today: "Hôm nay",
	},
	common: {
		cancel: "Hủy",
		confirm: "Xác nhận",
		sure: "Chắc chắn",
		delete: "Xóa",
		options: "tùy chọn",
		option: "tùy chọn",
		history: "Lịch sử",
		all: "Tất cả",
		setup: "Thiết lập",
	},
	chatMessageOrderDetails: {
		supplier: "Nhà cung cấp",
		orderBy: "Đặt bởi",
		billTo: "Hóa đơn tới",
		shipTo: "Giao tới",
		deliveryDate: "Ngày giao hàng",
		comment: "Bình luận",
		ordered: "Đã đặt",
		include: "Bao gồm",
		orderDetails: "Chi tiết đơn hàng",
	},
	generalization: {
		listTitle: "Danh sách quảng bá",
		searchPlaceholder: "Tìm kiếm",
		checkOut: "Xem chi tiết",
		sendAgain: "Gửi lại",
		send: "Gửi ngay",
		detailTitle: "Chi tiết quảng bá",
		isSendMessage: "Gửi tin nhắn cho",
	},
	messageSending: {
		title: "Khách hàng chưa đăng ký với OMELINK",
		customerName: "Tên khách hàng",
		customerPhone: "Điện thoại khách hàng",
		associatedRestaurantId: "ID nhà hàng liên kết",
		restaurantName: "Tên nhà hàng",
		operate: "Hành động",
		historyRecord: "Bản ghi lịch sử",
		sendMessage: "Gửi SMS",
		cancel: "Hủy",
		confirm: "Xác nhận gửi",
		restaurantId: "ID nhà hàng",
		close: "Đóng",
		orderId: "ID đơn hàng",
		snedText: "Nội dung đã gửi",
		sendTime: "Thời gian gửi",
		sendSuccess: "Gửi thành công",
		isCheckedDocument: "Xem tài liệu không?",
		isDownLoad: "Tải OMELINK không?",
		sendDocument: "Gửi tài liệu",
		true: "Có",
		false: "Không",
		check: "Xem",
	},
	aiEmail: {
		account: "Tài khoản email",
		accountDescription: "Cấu hình hộp thư dùng để nhận và xử lý email đặt hàng bằng AI.",
		configureAccount: "Cấu hình email",
		editAccount: "Chỉnh sửa email",
		emailAddress: "Địa chỉ email",
		emailPassword: "Mật khẩu email",
		passwordSetHint: "Mật khẩu đã được đặt. Để trống để giữ nguyên.",
		accountEnabled: "Bật xử lý email",
		enabled: "Đã bật",
		disabled: "Đã tắt",
		syncError: "Lỗi đồng bộ",
		latestSync: "Đồng bộ gần nhất",
		noSyncTime: "Chưa có",
		accountEmpty: "Chưa có tài khoản email nào được cấu hình. Hãy lưu địa chỉ email và mật khẩu để bắt đầu.",
		emailDisabledNotice: "Tài khoản email này đang bị tắt. Email sẽ không được đồng bộ hoặc xử lý, nhưng vẫn có thể quản lý liên hệ.",
		contacts: "Liên hệ email",
		contactsDescription: "AI chỉ xử lý email đặt hàng từ các liên hệ đã cấu hình.",
		addContact: "Thêm liên hệ",
		editContact: "Chỉnh sửa liên hệ",
		guestEmail: "Email khách hàng",
		processingMode: "Chế độ xử lý",
		automatic: "Tự động hoàn toàn",
		semiAutomatic: "Bán tự động",
		automaticDescription: "AI sẽ trả lời khách bằng tiếng Anh và tạo đơn hàng khi thông tin đầy đủ.",
		semiAutomaticDescription: "AI âm thầm nhận diện ý định đặt hàng và tạo đơn mà không trả lời khách.",
		associatedCustomers: "Customer liên kết",
		updatedAt: "Cập nhật lúc",
		actions: "Thao tác",
		edit: "Chỉnh sửa",
		delete: "Xóa",
		customerPlaceholder: "Chọn Customer",
		noCustomers: "Không có Customer khả dụng cho nhân viên bán hàng hiện tại.",
		loadingAccount: "Đang tải cài đặt email...",
		loadingContacts: "Đang tải liên hệ...",
		validatingConnection: "Đang xác minh kết nối email...",
		save: "Lưu",
		accountSaveSuccess: "Đã lưu cài đặt email.",
		statusUpdateSuccess: "Đã cập nhật trạng thái email.",
		contactCreateSuccess: "Đã tạo liên hệ.",
		contactUpdateSuccess: "Đã cập nhật liên hệ.",
		contactDeleteSuccess: "Đã xóa liên hệ.",
		validationEmail: "Nhập địa chỉ email hợp lệ.",
		validationPassword: "Cần nhập mật khẩu email khi lưu tài khoản lần đầu.",
		validationMode: "Chọn chế độ xử lý.",
		validationCustomers: "Chọn ít nhất một Customer.",
		confirmDelete: "Xác nhận xóa",
		deleteContactMessage: "Sau khi xóa, hệ thống sẽ không xử lý email mới từ {email}. Xóa liên hệ này?",
	},
	serviceMaintenance: {
		userList: "Danh sách người dùng",
		serviceProviderList: "Danh sách nhà cung cấp dịch vụ",
		customerName: "Tên khách hàng",
		customerPhone: "Điện thoại khách hàng",
		associatedRestaurantId: "ID nhà hàng liên kết",
		restaurantName: "Tên nhà hàng",
		operate: "Thao tác",
		serviceMaintenance: "Bảo trì nhà cung cấp dịch vụ",
		batchMaintenance: "Bảo trì hàng loạt nhà cung cấp dịch vụ",
		sort: "Thứ tự",
		applicationName: "Tên ứng dụng",
		type: "Phân loại",
		status: "Trạng thái",
		selectUsers: "Chọn người dùng",
		selectServiceProvider: "Chọn nhà cung cấp dịch vụ",
		complete: "Hoàn thành",
		nextStep: "Bước tiếp theo",
		previous: "Trước đó",
		selectServiceProviderTip: "Chọn các nhà cung cấp dịch vụ cần hiển thị (các nhà cung cấp không được chọn sẽ bị ẩn)",
		batchMaintenanceComplete: "Bảo trì hàng loạt hoàn tất",
		latestShelvesTime: "Thời gian cập nhật mới nhất",
		introduction: "Giới thiệu doanh nghiệp",
		businessName: "Tên doanh nghiệp",
		show: "Hiển thị",
		hide: "Ẩn",
		soft: "Phần mềm",
		service: "Dịch vụ",
		successfulOperation: "Thao tác thành công!",
	},
	openClawManagement: {
		guestName: "Tên khách hàng",
		guestPhoneNumber: "Điện thoại khách hàng",
		associatedRestaurantId: "ID nhà hàng liên kết",
		restaurantName: "Tên nhà hàng",
		status: "Trạng thái nhân viên số",
		operate: "Thao tác",
		show: "Hiển thị",
		hide: "Ẩn",
		noData: "Không có dữ liệu",
		loading: "Đang tải...",
		updateSuccess: "Thao tác thành công!",
	},
};
